export const Currencies = {
  nzd: 'nzd',
  aud: 'aud',
  usd: 'usd',
};
